import { useFormikContext } from 'formik'

/**
 * @deprecated This hook is Formik-specific. Use `useFormikContext` directly from 'formik' instead.
 * 
 * WARNING: This hook will throw a runtime error if used inside a React Hook Form context.
 */
export function useFormikFormContext() {
  return useFormikContext<any>()
}
